import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-none group-[.toaster]:rounded-none",
          description: "group-[.toast]:text-text-secondary text-xs",
          actionButton:
            "group-[.toast]:border group-[.toast]:border-foreground group-[.toast]:bg-background group-[.toast]:text-foreground group-[.toast]:text-xs group-[.toast]:px-3 group-[.toast]:py-1 group-[.toast]:rounded-full group-[.toast]:hover:bg-surface-hover",
          cancelButton:
            "group-[.toast]:border group-[.toast]:border-border group-[.toast]:bg-background group-[.toast]:text-text-secondary group-[.toast]:text-xs group-[.toast]:px-3 group-[.toast]:py-1 group-[.toast]:rounded-full group-[.toast]:hover:bg-surface-hover",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
